import React from 'react'
import { FaPhoneAlt } from 'react-icons/fa'
import { IoIosMail } from 'react-icons/io'
import { FaInstagram } from 'react-icons/fa'
import { FaLinkedin } from 'react-icons/fa'
import { FaFacebookSquare } from 'react-icons/fa'

import { logos } from '../Assets/Logo/logos'

const FooterPage = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-content">
          <img src={logos.saude10} alt="Logo Ammarhes" />
          <p>
            Av. Embaixador Abelardo Bueno, 1 - loja 108 - Barra da Tijuca
            <br />
            CNPJ: 35.839.991/0001-85
          </p>
        </div>
        <div className="footer-content1">
          <p>
            <FaPhoneAlt />
            <a className="span-footer" href="tel:+552122629752">
              +55 (21) 2262-9752
            </a>
          </p>
          <p>
            <FaPhoneAlt />
            <a className="span-footer" href="tel:+552135491640">
              +55 (21) 3549-1640
            </a>
          </p>
          <p>
            <FaPhoneAlt />
            <a className="span-footer" href="tel:+552120260011">
              +55 (21) 2026-0011
            </a>
          </p>
          <p>
            <IoIosMail />
            <a href="mailto:comercial@ammarhes.com.br">
              Comercial:
              <span className="span-footer"> comercial@ammarhes.com.br</span>
            </a>
          </p>
          <p>
            <IoIosMail />
            <a href="mailto:ouvidoria@ammarhes.com.br">
              Ouvidoria:
              <span className="span-footer"> ouvidoria@ammarhes.com.br</span>
            </a>
          </p>
        </div>
      </div>
      <hr />
      <div className="bottom-footer">
        <div className="socialMedias">
          <a
            href="https://www.facebook.com/Ammarhesconsultoria/"
            aria-label="https://www.facebook.com/Ammarhesconsultoria/"
            target="_blank"
          >
            <FaFacebookSquare />
          </a>
          <a
            href="https://www.linkedin.com/in/ammarhesconsultoria/"
            aria-label="https://www.linkedin.com/in/ammarhesconsultoria/"
            target="_blank"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://www.instagram.com/ammarhesconsultoria/"
            aria-label="https://www.instagram.com/ammarhesconsultoria/"
            target="_blank"
          >
            <FaInstagram />
          </a>
        </div>
        &copy; {new Date().getFullYear()} Copyright:
        <p>Saúde 10</p>
      </div>
    </footer>
  )
}

export default FooterPage
